<template>
  <div :class="classes">
    <pt-page-title title="积分商品审核" ></pt-page-title>
    <pt-page-menu-filter :tabs="tabs" v-model="selectTab" @fromRouter="fromRouter"></pt-page-menu-filter>
    <pt-integral-goods-table :tableLabels="tableLabels" ref="table" :paramsData="paramsData">
      <template>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <template v-if="HAS_PERM_P_002">
          <el-button type="text" v-if="scope.row.goodsDTO.state=='WAITING_FOR_APPROVAL'" @click="examine(scope.row)">审核发布</el-button>
          <el-button type="text" v-if="scope.row.goodsDTO.state=='WAITING_FOR_APPROVAL'" @click="reject(scope.row)">驳回</el-button>
          <el-button type="text" v-if="scope.row.goodsDTO.state=='PUBLISHED'" @click="offTheShelf(scope.row)">下架</el-button>
            </template>
          <el-button type="text" @click="review(scope.row)">预览</el-button>
          <el-button type="text" @click="getDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </template>
    </pt-integral-goods-table>
    <el-dialog :visible.sync ="is_review" title="商品上架确认" :class="$style['review-dialog']" @close="closeDialog">
      <review-goods :goodsDetail="goodsDetail" @closeDialog="closeDialog" v-if="is_review" fromPage="integral"></review-goods>
    </el-dialog>
      <review-goods-iframe :is-dialog="is_review_iframe"  @closeDialog="closeDialog" :goods-id="review_id" integral></review-goods-iframe>
  </div>
</template>

<script>
// 组件class前缀
import { pageStutesTabs, goodsTableLabelOfView, WAITING_FOR_APPROVAL, PUBLISHED, OFF_SHELVES } from '../integral-goods-option'
import { arrInsert } from 'utils/formUtils'
import { hasPermissions } from 'utils/permissions'
import ptIntegralGoodsTable from '../pt-integral-goods-table/withData'
import reviewGoods from 'cps/mall-manage/pt-goods-review/review-goods'
import reviewGoodsIframe from 'cps/mall-manage/pt-goods-manage/review-goods-iframe'
const prefixCls = 'pt-integral-goods-review'
const PERM_P_002 = 'PERM_P_002'// 商品管理权限
export default {
  name: 'pt-integral-goods-review',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    HAS_PERM_P_002 () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_P_002)
    }
  },
  components: {
    ptIntegralGoodsTable,
    reviewGoods,
    reviewGoodsIframe
  },
  data () {
    return {
      tabs: pageStutesTabs,
      selectTab: null,
      paramsData: {},
      is_review: false,
      goodsDetail: {},
      review_id: null,
      is_review_iframe: false,
      tableLabels: goodsTableLabelOfView
    }
  },
  watch: {
    selectTab: {
      handler: function (val, old) {
        // this.paramsData = null
        this.paramsData = { ...this.$route.query }
        switch (val) {
          case 'PUBLISHED':
            this.tableLabels = arrInsert(goodsTableLabelOfView, 2, PUBLISHED)
            break
          case 'OFF_SHELVES':
            this.tableLabels = arrInsert(goodsTableLabelOfView, 2, OFF_SHELVES)
            // this.tableLabels = goodsTableLabelOfView.concat(OFF_SHELVES)
            break
          default:
            // this.tableLabels = arrInsert(goodsTableLabelOfView, 2, WAITING_FOR_APPROVAL)
            // this.tableLabels = goodsTableLabelOfView.concat(WAITING_FOR_APPROVAL)
            break
        }
        // this.tableLabels = goodsTableLabelOfView.concat(val)
      },
      immediate: true
    }
  },
  methods: {
    closeDialog (val) {
      this.is_review = false
      this.is_review_iframe = false
      if (val) {
        this.getTableData()
      }
    },
    fromRouter (val) {
      this.isFromRouter = val
    },
    examine (val) {
      this.is_review = true
      this.goodsDetail = val
    },
    reject (val) {
      this.$confirm('您确定驳回该商品上架请求吗', '商品上架驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$emit('approvalReject', val.goodsDTO.id)
      })
    },
    offTheShelf (val) {
      this.$confirm('您确定将该商品下架吗', '商品下架', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$emit('offTheShelf', val.goodsDTO.id)
      })
    },
    review (row) {
      this.is_review_iframe = true
      this.review_id = row.goodsDTO.id
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    getDetail (row) {
      this.$router.push('/integral-goods-detail/' + row.goodsDTO.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
